var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 21H35","stroke":"#FBF8F4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M22.75 8.75L35 21L22.75 33.25","stroke":"#FBF8F4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Arrow.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
